import(/* webpackMode: "eager" */ "/home/forge/www.medkart.in/releases/82082909/app/csr/[locale]/[device]/[...slug]/error.tsx");
